import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)
export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/Login')
    },
    {
      path: '/',
      name: 'map',
      meta: {
        requiresAuth: true
      },
      component: () => import('@/components/Map')
    }
  ]
})
